<template>
  <b-container
    class="container-md"
    fluid
  >
    <div
      class="d-flex content align-items-center m-0 "
      style="width: 50%"
    />
    <b-row class="justify-content-between">
      <b-col
        cols="auto"
        class="p-3"
      >
        <BButton
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          class="my-button"
          variant="outline-secondary"
          @click="goToFiles"
        >
          <FontAwesomeIcon icon="arrow-left" />
          <span class="ml-1">Torna ai File</span>
        </BButton>
      </b-col>
      <b-col
        cols="auto"
        class="p-3"
      >
        <b-button
          variant="primary"
          @click="newModal"
        >
          <FontAwesomeIcon
            class="margin"
            icon="fw fa-plus"
            size="xl"
          />
          Aggiungi Utente
        </b-button>
      </b-col>
    </b-row>
    <b-row align-h="end">
      <b-col
        class="my-1"
        lg="6"
      >
        <b-form-group
          class="mb-0"
          label-align-sm="right"
          label-cols-sm="3"
          label-for="filter-input"
          label-size="sm"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filter-input"
              v-model="filter"
              placeholder="Cerca"
              type="search"
            />

            <b-input-group-append>
              <b-button
                :disabled="!filter"
                class="btn-warning"
                @click="filter = ''"
              >
                Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row align-h="end">
      <b-table
        :fields="fields"
        :items="items"
        :bordered="bordered"
        :borderless="borderless"
        :current-page="currentPage"
        :dark="dark"
        :filter="filter"
        :filter-included-fields="filterOn"
        :fixed="fixed"
        :foot-clone="footClone"
        :head-variant="headVariant"
        :hover="hover"
        :no-border-collapse="noCollapse"
        :outlined="outlined"
        :per-page="perPage"
        :small="small"
        :striped="striped"
        :table-variant="tableVariant"
      >
        <template #cell(actions)="row">
          <b-row>
            <b-button
              size="sm"
              class="m-1"
              variant="primary"
              :disabled="row.item.profile.label === 'Admin'"
              @click="blockUser(row)"
            >
              Elimina
            </b-button>

            <b-button
              size="sm"
              class="m-1"
              variant="primary"
              @click="editUser(row)"
            >Cambia Ruolo</b-button>
          </b-row>

        </template>
        <template #cell(name)="row">
          <span v-html="row.value" /></template>
      </b-table>
    </b-row>
    <b-row>
      <b-col
        class="my-1"
        md="6"
        sm="5"
      >
        <b-form-group
          class="mb-0"
          label="Per pagina"
          label-align-sm="right"
          label-cols-lg="3"
          label-cols-md="4"
          label-cols-sm="6"
          label-for="per-page-select"
          label-size="sm"
        >
          <b-form-select
            id="per-page-select"
            v-model="perPage"
            :options="pageOptions"
            size="sm"
          />
        </b-form-group>
      </b-col>

      <b-col
        class="my-1"
        md="6"
        sm="7"
      >
        <b-pagination
          v-model="currentPage"
          :per-page="perPage"
          :total-rows="totalRows"
          align="fill"
          class="my-0"
          size="sm"
        />
      </b-col>
    </b-row>

    <AddUserModal
      :groups-list="groupList"
      @reload="getUserList"
    />
    <EditUserModal
      :groups-list="groupList"
      :user="selectedUser"
      @reload="getUserList"
    />
  </b-container>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import AddUserModal from '@/layouts/components/modals/AddUserModal.vue'
import EditUserModal from '@/layouts/components/modals/EditUserModal.vue'
import Ripple from 'vue-ripple-directive'

import {
  BButton,
  BCol,
  BContainer,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BInputGroup,
  BRow,
  BTable,
  BPagination,
  BInputGroupAppend,
} from 'bootstrap-vue'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import * as dateHelpers from '@/helpers/date-helpers'
import { capitalizeFirstLetter } from 'vue2-leaflet'

const authRepository = RepositoryFactory.get('auth')
const groupRepository = RepositoryFactory.get('group')

export default {
  components: {
    BContainer,
    BInputGroupAppend,
    BInputGroup,
    BRow,
    BCol,
    BTable,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BPagination,
    AddUserModal,
    EditUserModal,
    FontAwesomeIcon,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      fields: [
        {
          key: 'id',
          label: '',
          sortable: true,
        },
        {
          key: 'name',
          label: 'Name',
          sortable: true,
        },
        {
          key: 'email',
          label: 'Email',
          sortable: true,
        },
        {
          key: 'profile.label',
          label: 'Ruolo',
        },
        {
          key: 'created_at',
          label: 'data creazione',
          sortable: true,
        },
        {
          key: 'updated_at',
          label: 'data modifica',
          sortable: true,
        },
        {
          key: 'actions',
          label: 'Actions',
          sortable: false,
          thStyle: {
            width: '20%',
          },
        },
      ],
      items: [],
      editData: {
        id: '',
        label: '',
      },
      groupList: [],
      tableVariants: [
        'primary',
        'secondary',
        'info',
        'danger',
        'warning',
        'success',
        'light',
        'dark',
      ],
      striped: false,
      bordered: false,
      borderless: false,
      outlined: false,
      small: false,
      hover: false,
      dark: false,
      fixed: false,
      footClone: false,
      headVariant: null,
      tableVariant: '',
      noCollapse: false,
      filter: null,
      filterOn: ['name'],
      perPage: 20,
      pageOptions: [2, 5, 10, 20, 50, 100],
      currentPage: 1,
      loadingShow: false,
      selectedUser: null,
    }
  },
  computed: {
    totalRows() {
      return this.items.length
    },
  },
  mounted() {
    this.getGroupList()
    this.getUserList()
  },
  methods: {
    async getUserList() {
      this.loadingShow = true
      this.selectedUser = null
      this.items = []
      const { data } = await authRepository.list()
      console.log(data)
      data.data.forEach(e => {
        e.name = e.blocked_at === null ? this.$options.filters.ucfirst(e.name) : `<del>${this.$options.filters.ucfirst(e.name)}</del>`
        e.created_at = this.dateHelpers.format(e.created_at)
        e.updated_at = this.dateHelpers.format(e.updated_at)
        e.profile.label = this.$options.filters.ucfirst(e.profile.label).replace('_', ' ')
        e.blocked = e.blocked_at === null ? 'NO' : 'SI'
        if (e.blocked_at === null) {
          this.items.push(e)
        }
      })
      this.loadingShow = false
    },

    goToFiles() {
      this.$router.push('/files')
    },
    newModal() {
      this.$bvModal.show('userAdd-modal')
    },
    async blockUser(row) {
      console.log(row.item.id)
      await authRepository.toggleLock(row.item.id)
      await this.getUserList()
    },
    editUser(row) {
      this.selectedUser = row.item
      this.$bvModal.show('editUser-modal')
    },
    async getGroupList() {
      const { data } = await groupRepository.indexSystem({ type: 'system' })
      if (data.code) {
        data.data.forEach(group => {
          this.groupList.push({
            text: capitalizeFirstLetter(group.label).replace('_', ' '),
            value: group.id,
          })
        })
      }
    },
  },
}
</script>
